import React, { useContext } from 'react'
import { NavigationContext } from '../context/NavigationContext'
import { Link } from 'react-router-dom'
import Icon from '../res/icons'

const MenuItem = (props) => {
    const { currentPage } = props
    const { page } = useContext(NavigationContext)
    return (
        <Link to={currentPage.uri} key={currentPage.uri}>
            <div className={`menu-link ${currentPage.id === page.id && 'active'}`}>
                <div className="menu-icon">
                    {currentPage.icon !== '' && <Icon name={currentPage.icon} height={'24px'} fill={currentPage.id === page.id && '#3889FE' || '#4A4A4A'} />}
                </div>
                <div className="menu-title">
                    {currentPage.titre_court}
                </div>
            </div>
        </Link>
    );
}

export default MenuItem;